import { useIsFeatureFlagEnabled } from "../../../tools/useIsFeatureFlagEnabled"
import { KpiSalesHeaderLoader } from "../KpiSalesHeader/KpiSalesHeaderLoader"
import { UserInfoHeader } from "../UserInfoHeader"
import { UserInfoHeaderSkeleton } from "../UserInfoHeader/UserInfoHeaderSkeleton"

type SubHeadersProps = {
  showUserInfoHeader?: boolean
}
export const SubHeaders = ({ showUserInfoHeader = true }: SubHeadersProps) => {
  const { isFlagsLoaded, isCompletedCoursesStarsEnabled, isKpiSalesEnabled } =
    useFeatureFlags()

  const shouldShowUserInfoHeader =
    isCompletedCoursesStarsEnabled && showUserInfoHeader

  if (!isFlagsLoaded) return <UserInfoHeaderSkeleton />

  return (
    <>
      {shouldShowUserInfoHeader && <UserInfoHeader />}
      {isKpiSalesEnabled && <KpiSalesHeaderLoader />}
    </>
  )
}

const useFeatureFlags = () => {
  const { getIsPortalFlagEnabled, isFlagsLoaded } = useIsFeatureFlagEnabled()

  const isCompletedCoursesStarsEnabled = !getIsPortalFlagEnabled(
    "disable_completed_courses_stars"
  )
  const isKpiSalesEnabled = getIsPortalFlagEnabled("enable_kpi_sales_tiles")

  return {
    isFlagsLoaded,
    isCompletedCoursesStarsEnabled,
    isKpiSalesEnabled,
  }
}
